import { render, staticRenderFns } from "./AffiliationRow.vue?vue&type=template&id=b5a24ca6&"
import script from "./AffiliationRow.vue?vue&type=script&lang=js&"
export * from "./AffiliationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports